<template>
  <div class="level-result-wrapper">
    <div class="main">
      <img v-if="levelInfo.star >= 2" class="head" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/89575d9e23d313ee94f0466a1ebf7c7b.png" alt="">
      <img v-else class="head" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/7ae3ff18a8405c974715780cbae88ec8.png" alt="">
      <div class="star-wrapper">
        <img v-show="levelInfo.star >= 1" class="left" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/d6e16c80cdaa89a79b17cb0caf99b7c8.png" alt="">
        <img v-show="levelInfo.star >= 2" class="center" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/d6e16c80cdaa89a79b17cb0caf99b7c8.png" alt="">
        <img v-show="levelInfo.star >= 3" class="right" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/d6e16c80cdaa89a79b17cb0caf99b7c8.png" alt="">
        <img v-show="levelInfo.star < 1" class="left" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/6881791de105851d8ab4c3c959ca3ded.png" alt="">
        <img v-show="levelInfo.star < 2" class="center" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/6881791de105851d8ab4c3c959ca3ded.png" alt="">
        <img v-show="levelInfo.star < 3" class="right" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/6881791de105851d8ab4c3c959ca3ded.png" alt="">
      </div>
      <div class="board">
        <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/84d3de8740929482a44afd4e314e82bf.png" alt="">
        <div class="board-info">
          <div class="board-title">{{levelInfo.star >= 1 ? '恭喜你闯关成功 !' : '闯关失败 !'}}</div>
          <div v-if="levelInfo.star >= 1 ">积分 +{{levelInfo.score}}</div>
          <div>经验 +{{levelInfo.exp}}</div>
        </div>
      </div>
      <div class="control">
        <div
          class="btn btn-orange-square btn-circle"
          @click="handleContinue">{{levelInfo.star >= 1 ? '下一关' : '重新闯关'}}</div>
        <div
          class="btn btn-blue-square"
          @click="close">结束闯关</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    levelInfo: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    handleContinue() {
      const type = this.levelInfo.star < 1 ? 'replay' : 'next';
      this.$emit('continue', type);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .level-result-wrapper {
    width: 100%;
    height: 100%;
    background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/afff85934fb4cde4be2c841840180fa8.png')
      no-repeat center center / cover;
    background-color: #1a1547;
    .main {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      .head {
        width: 50%;
      }
      .star-wrapper {
        display: flex;
        justify-content: center;
        position: absolute;
        top: 7%;
        left: 50%;
        transform: translateX(-50%);
        img {
          width: 25%;
        }
        .left {
          transform: translateY(10%) rotate(-15deg);
        }
        .center {
          transform: translateY(-10%);
        }
        .right {
          transform: translateY(10%) rotate(15deg);
        }
      }
      .board {
        position: relative;
        width: 35%;
        img {
          width: 100%;
        }
        .board-info {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: #fff;
          text-align: center;
          div {
            margin: 3% 0;
            font-size: 2.5vh;
          }
          .board-title {
            margin: 2% 0;
            font-size: 3.5vh;
            font-weight: 700;
          }
        }
      }
      .control {
        margin-top: 3vh;
        display: flex;
        justify-content: center;
        width: 100%;
        .btn {
          margin: 0 4vh;
          width: 20vh;
          height: 6vh;
          font-size: 2.5vh;
          border-radius: 30px;
        }
      }
    }
  }
</style>
